import React from 'react';
import { LiveTripsForSchool } from '../types';
import { PaperWrapper } from '../../common/styled';
import { DataGrid } from '@mui/x-data-grid';
import { dataGridSx } from '../../common/styled/DataGrid';
import pallet from '../../../layouts/pallet';
import { getLiveTripsColumns } from '../utils/getLiveTripsColumns';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';

const LiveTripsTable = ({
  liveTripsData,
  endTrip,
  sosAlert
}: {
  liveTripsData: LiveTripsForSchool[];
  endTrip: (tripData: LiveTripsForSchool) => void;
  sosAlert: (tripData: LiveTripsForSchool) => void;
}) => {
  const columns = getLiveTripsColumns(endTrip, sosAlert);
  return (
    <PaperWrapper>
      <DataGrid
        rowHeight={50}
        rows={liveTripsData}
        columns={columns}
        disableRowSelectionOnClick
        pageSizeOptions={[5, 10, 25]}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 }
          },
          columns: {
            ...columns,
            columnVisibilityModel: {
              id: false
            }
          }
        }}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true
          }
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </PaperWrapper>
  );
};

export default LiveTripsTable;
